import ClassicExtension from "./ClassicExtension";
import linkifyHtml from "linkify-html";

/**
 * Replace plaintext links by <a href="link">link</a>
 * in elements with attribute data-linkify
 */
export default class LinkifyExtension extends ClassicExtension {
    protected init($root: JQuery): void {
        $root.find('[data-linkify]').each((i, el) => {

            el.innerHTML = linkifyHtml(el.innerHTML, {
                defaultProtocol: "https",
                target: href => {
                    // open links points-out of current domain in new tab
                    return href.startsWith(window.location.origin) ? "_self" :  "_blank"
                }
            });

            delete el.dataset.linkify;
        });
    }
}
